import { Toast, DeviceInfo } from 'qunar-react-native';

const toast: (params: { msg: string; position?: number }) => void = ({
    msg,
    position = Toast.BOTTOM
}) => Toast.show(msg, DeviceInfo.isIOS ? 2000 : Toast.SHORT, position);

// global.$toast = toast;
export { toast };
